// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".powerchat-link {\n  font-size: 34px;\n  font-family: 'Arial Black';\n  width: fit-content;\n  padding: 4px;\n  filter: drop-shadow(4px 4px 4px #000);\n}\n\n.powerchat-link .username {\n  margin-left: 2px;\n  position: relative;\n  top: -6px;\n}\n", ""]);
// Exports
module.exports = exports;
